/**
 *
 * Asynchronously loads the component for SoftwareInventory
 *
 */

import { lazy } from 'react';

export const SoftwareInventory = lazy(() =>
  import('./index').then(m => ({ default: m.SoftwareInventory })),
);
